"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var ReplaceTransform =
/** @class */
function (_super) {
  __extends(ReplaceTransform, _super);

  function ReplaceTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ReplaceTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var response = queryResponse;

    if (this.options.replaceTransformOptions) {
      var _a = this.options.replaceTransformOptions,
          searchValue = _a.searchValue,
          replaceValue = _a.replaceValue,
          _b = _a.isRegex,
          isRegex = _b === void 0 ? false : _b,
          regexFlags = _a.regexFlags;

      if (typeof response === 'string' && typeof searchValue === 'string' && typeof replaceValue === 'string') {
        if (isRegex) {
          response = response.replace(new RegExp(searchValue, regexFlags), replaceValue);
        } else {
          response = response.split(searchValue).join(replaceValue);
        }
      }
    }

    return response;
  };

  return ReplaceTransform;
}(BaseTransform_1.BaseTransform);

exports.ReplaceTransform = ReplaceTransform;